import { Amplify } from 'aws-amplify';
import awsconfig from './aws-exports';

// Configure Amplify with Cognito User Pool as the authentication mechanism
export const configureAmplify = () => {
  // Configure Amplify for AWS SDK v6
  Amplify.configure(awsconfig);
};